"use client";
import { useEffect } from "react";

/**
 * Performs a client-side redirect after a short delay so that crawlers
 * (e.g. WhatsApp) have time to read the OG metadata before being redirected.
 */
export default function ClientRedirect({ redirectUrl }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.replace(redirectUrl);
    }, 1000);
    return () => clearTimeout(timer);
  }, [redirectUrl]);

  return null;
}
